module.exports = __webpack_public_path__ + "32aae31fb2fac9c89d47d5b35e7142f9.pdf";